export const TRAITS = [
	'initiator',
	'motivator',
	'inspirator',
	'advisor',
	'supporter',
	'coordinator',
	'observer',
	'reformer'
]

export const TRAIT_LABELS = {
	reformer: 'Architect',
	observer: 'Examiner',
	coordinator: 'Steward',
	supporter: 'Stabilizer',
	initiator: 'Catalyst',
	motivator: 'Amplifier',
	inspirator: 'Illuminator',
	advisor: 'Navigator'
}

export const BASELINE = 12.5
